export type YoutubeRawImportType =
  | 'asset_summary'
  | 'asset_summary_adj'
  | 'red_music_asset'
  | 'red_non_music_asset'
  | 'ecommerce_paid_feature'
  | 'shorts_non_music_subscriptions_video'
  | 'shorts_non_music_ads_video'
  | 'channel_adjustment'
  | 'affiliate_tax_refund'
  | 'affiliate_payment_summary'

export const YoutubeRawImportType_AllValues: YoutubeRawImportType[] = [
  'asset_summary',
  'asset_summary_adj',
  'red_music_asset',
  'red_non_music_asset',
  'ecommerce_paid_feature',
  'shorts_non_music_subscriptions_video',
  'shorts_non_music_ads_video',
  'channel_adjustment',
  'affiliate_tax_refund',
  'affiliate_payment_summary',
]

export type YoutubeAutomaticRawImportType =
  | 'content_owner_asset_ad_revenue_summary_a1'
  | 'content_owner_music_asset_red_revenue_raw_a1'
  | 'content_owner_non_music_asset_red_revenue_raw_a1'
  | 'content_owner_asset_ad_adjustment_revenue_summary_a1'
  | 'content_owner_shorts_ad_revenue_summary_a2'
  | 'content_owner_shorts_red_revenue_video_summary_a1'
export const YoutubeAutomaticRawImportType_AllValues: YoutubeAutomaticRawImportType[] = [
  'content_owner_asset_ad_revenue_summary_a1',
  'content_owner_music_asset_red_revenue_raw_a1',
  'content_owner_non_music_asset_red_revenue_raw_a1',
  'content_owner_asset_ad_adjustment_revenue_summary_a1',
  'content_owner_shorts_ad_revenue_summary_a2',
  'content_owner_shorts_red_revenue_video_summary_a1',
]

export const SourceHelper = {
  SOURCES: [
    {
      value: 'Logicomix',
      label: 'Logicomix',
    },
    {
      value: 'Logicomix Network',
      label: 'Logicomix Network',
    },
    {
      value: 'Bump',
      label: 'Bump',
    },
    {
      value: 'Endemol',
      label: 'BMF',
    },
    {
      value: 'TV5 Monde',
      label: 'TV5 Monde',
    },
    {
      value: 'France TV Médias',
      label: 'France TV Médias',
    },
  ],
  cmsToYoutubeChannelCms: (cmsId: string) => {
    if (cmsId === 'bump') {
      return 'BUMP'
    }
    if (cmsId === 'endemol') {
      return 'endemol'
    }
    if (cmsId === 'tv5monde') {
      return 'TV5 Monde'
    }
    if (cmsId === 'france_tv_medias') {
      return 'France TV Médias'
    }
    if (cmsId === 'logicomix') {
      return ['Logicomix', 'Logicomix Network']
    }
  },
}
